import OverviewSection from "./OverviewSection";
import AccountDetails from "./AccountDetails";
import AssetAllocation from "./AssetAllocation";
import InvestmentsTable from "./InvestmentsTable";
import ActionButtons from "./ActionButtons";
import XirrPerformance from "./XirrPerformance";
import { useEffect, useState } from "react";
import { Registration } from "@/utils/types/NPS/Stepper/GetRegistrationDetils";
import UserXirrService from "@/services/NPS/NpsUser/APIs/UserXirr";
import { XirrData } from "@/utils/types/UserXirr";

const OverviewContent: React.FC<{
  registrationDetails: Registration | null;
}> = ({ registrationDetails }) => {
  const [financialYear, setFinancialYear] = useState("2025-2026");
  const [quarter, setQuarter] = useState("Q3");
  const [data, setData] = useState<XirrData | null>(null);

  useEffect(() => {
    const fetchData = async () => {
      const res = await UserXirrService.getUserXirr(quarter, financialYear);
      if (res.success) {
        setData(res.xirrData);
      }
    };
    fetchData();
  }, [quarter, financialYear]);

  return (
    <div className="mt-6 space-y-6">
      {/* Stats */}
      <OverviewSection
        quarter={quarter}
        setQuarter={setQuarter}
        financialYear={financialYear}
        setFinancialYear={setFinancialYear}
        data={data}
      />
      <XirrPerformance data={data} />
      {/* Account + Allocation */}
      <div className="mb-6 grid grid-cols-1 gap-6 lg:grid-cols-[1fr_2fr]">
        <AccountDetails registrationDetails={registrationDetails} />
        <AssetAllocation registrationDetails={registrationDetails} />
      </div>

      {/* Investments */}
      <InvestmentsTable />

      {/* Transactions */}
      <ActionButtons />
    </div>
  );
};

export default OverviewContent;
